import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {Link, useLocation} from "react-router-dom";

export function JobEventView() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const job = useLocation().state

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>

                <div>
                    <Link to={"/management/jobs/view"} state={job}>
                        <button className="btn btn-secondary float-start m-0 pb-0 pt-0">← Overview</button>
                    </Link>
                    <br/>


                    <div className="page-title-sh26">
                        <h1>Timeline for #{job.id}</h1>
                        <p> {job.name}</p>
                        <hr/>
                    </div>


                    <div className=" w-25 h-100 float-start timeline">
                        <div className="timeline-button float-start timeline-button-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className=" timeline-button float-start ">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Enquiry Submitted</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {new Date(job.dates.enquiryReceived).toLocaleString().slice(0, 9)}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Enquiry Approved</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {job.dates.enquiryApproved}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Designs uploaded</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {job.dates.designsUploaded}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Favourite design chosen by customer</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {job.dates.designChosen}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Installation paid for</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {job.dates.designsCompleted}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Files printed</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {job.dates.printFilesCompleted}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Installation Scheduled</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {job.dates.installationScheduled}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Installation completed</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {job.dates.installationComplete}
                        </p>
                    </div>

                </div>

                <div className="page-break w-100 ">
                    <p> . </p>
                </div>

            </AuthenticatedTemplate>

        </div>
    );
}
